var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 64,
    fill: "none",
    viewBox: "0 0 77 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "m2.013 52.513-1.498.076 2.996.004-1.498-.08ZM23 44v1.5h1.5V44H23ZM3.5 12A8.5 8.5 0 0 1 12 3.5v-3C5.649.5.5 5.649.5 12h3Zm0 40V12h-3v40h3Zm.011.438A8.666 8.666 0 0 1 3.5 52h-3c0 .197.005.394.015.589l2.996-.151Zm0 .155A7.5 7.5 0 0 1 11 45.5v-3C5.391 42.5.81 46.897.515 52.433l2.996.16ZM11 45.5h12v-3H11v3ZM21.5 5v39h3V5h-3ZM20 3.5A1.5 1.5 0 0 1 21.5 5h3A4.5 4.5 0 0 0 20 .5v3Zm-8 0h8v-3h-8v3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M23 12v-1.5h-1.5V12H23Zm0 32v1.5h1.5V44H23Zm0-30.5h49v-3H23v3ZM24.5 44V12h-3v32h3ZM11 45.5h12v-3H11v3ZM3.5 53a7.5 7.5 0 0 1 7.5-7.5v-3C5.201 42.5.5 47.201.5 53h3Zm7.5 7.5A7.5 7.5 0 0 1 3.5 53h-3c0 5.799 4.701 10.5 10.5 10.5v-3Zm12 0H11v3h12v-3Zm3 0h-3v3h3v-3Zm46 0H26v3h46v-3Zm1.5-1.5a1.5 1.5 0 0 1-1.5 1.5v3a4.5 4.5 0 0 0 4.5-4.5h-3Zm0-44v44h3V15h-3ZM72 13.5a1.5 1.5 0 0 1 1.5 1.5h3a4.5 4.5 0 0 0-4.5-4.5v3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E4E4E",
    strokeDasharray: "5 5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M31 41v-7.75a7.75 7.75 0 0 1 7.75-7.75v0a7.75 7.75 0 0 1 7.75 7.75v9.25A7.5 7.5 0 0 0 54 50v0a7.5 7.5 0 0 0 7.5-7.5V41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 29.5,
    r: 5,
    stroke: "#4E4E4E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigator);
export default __webpack_public_path__ + "static/media/icon_navigator.76118674.svg";
export { ForwardRef as ReactComponent };